import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReportTypes } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-report-run-banner',
  templateUrl: './report-run-banner.component.html',
  styleUrls: ['./report-run-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportRunBannerComponent {
  bannerTypes = ReportTypes.ReportRunBannerTypes;
  @Input() bannerType: ReportTypes.ReportRunBannerType = ReportTypes.ReportRunBannerTypes.NoBanner;
  @Input() runCompletedAt!: Date;
  @Input() lastSuccessfullyRunAt!: Date;
  @Input() reportLink!: string;
  @Input() mostRecentReportRunLink!: string;
  @Input() reportRunErrorLink!: string;
  @Input() reportRunDetailsLink!: string;
}
